export const SET_ACTIVE_TOOLTIP = "SET_ACTIVE_TOOLTIP";
export const DELETED_ACTIVE_TOOLTIP = "DELETED_ACTIVE_TOOLTIP";
